<template>
  <div class="my-main-content-web">
    <div style="margin-top:5vh;  padding-bottom: 48px;max-width: 1280px; margin-right: 8vw; margin-left: 8vw;">
      <h3 class="text3D no-print">
        <span @click="$routerTo('/Admin')" style="border-bottom: 1px solid;cursor: pointer;">後台設定</span>
        <span> / </span>
        <span>製作 QRcode </span>
      </h3>

      <el-row class="no-print" type="flex" justify="center" style="margin-top:10px">
        <el-col :span="24">
          <el-radio-group v-model="selected_floor" @change="changeFloor" size="small">
            <el-radio-button style="color:white" :label="0">QRcode</el-radio-button>
            <!-- <el-radio-button style="color:white" :label="1">1樓</el-radio-button> -->
            <!-- <el-radio-button style="color:white" :label="2">2樓</el-radio-button> -->
            <!-- <el-radio-button style="color:white" :label="3">3樓</el-radio-button> -->
            <el-radio-button style="color:white" :label="4">首頁</el-radio-button>
          </el-radio-group>
        </el-col>
      </el-row>

      <el-row v-if="selected_floor == '1' || selected_floor == '2' || selected_floor == '3'" class="no-print" style="margin-top: 10px; text-align: left">
        <el-radio-group v-model="selected_area" @change="changeArea">
          <el-radio style="color: white; margin: 0; width: 20%" v-for="(area, index) in areas_options" :key="index" :label="area">{{ area["area_zh-TW"] }}</el-radio>
        </el-radio-group>
      </el-row>

      <div v-if="selected_floor == '0'" class="no-print" style="margin-top: 10px; text-align: left">
        <el-radio-group v-model="selected_qrcode" @change="changeQRcode">
          <el-radio style="color: white; margin: 0; width: 20%" v-for="(item, index) in qrcode_options" :key="index" :label="item">{{ item["name_zh-TW"] }}</el-radio>
        </el-radio-group>
      </div>

      <h4 class="no-print">編輯文字</h4>
      <div class="no-print" style="background-color:white;color:black">
        <vue-editor v-model="textarea"></vue-editor>
      </div>

      <h4 class="no-print">範本</h4>
      <el-button class="no-print" type="info" @click="setSize(1)" style="margin-top: 10px; margin-bottom: 10px">200px</el-button>
      <el-button class="no-print" type="info" @click="setSize(2)" style="margin-top: 10px; margin-bottom: 10px">250px</el-button>
      <el-button class="no-print" type="info" @click="setSize(3)" style="margin-top: 10px; margin-bottom: 10px">300px</el-button>
      <el-button class="no-print" type="info" @click="setSize(4)" style="margin-top: 10px; margin-bottom: 10px">350px</el-button>
      <el-button class="no-print" type="info" @click="setSize(5)" style="margin-top: 10px; margin-bottom: 10px">400px</el-button>

      <div>
        <el-card :body-style="{ padding: '0px' }" style="background-color: white;color: black;margin: 5px">
          <!-- <div style="margin-top: 15px;">
            <img src="../../public/logo.png" :width="img_size" />
          </div> -->

          <div style="margin-top: 15px;">
            <span :style="font_size" style="display: block;color: red;font-weight: bold;">TAOG MUSEUM</span>
          </div>

          <h3>
            <span v-if="selected_floor == '4'" :style="font_size">首頁</span>
            <span :style="font_size">{{ selected_qrcode["name_zh-TW"] }}</span>
          </h3>

          <!-- <h3 v-if="area_ID == -1">
          <span :style="font_size"></span>
        </h3>
        <h3 v-else-if="area_ID">
          <span :style="font_size">{{ floor }}樓 -- {{ area }}</span>
        </h3>
        <h1 v-else>請選擇樓層及區域</h1> -->

          <div @click="newPage()">
            <qrcode-vue v-if="area_ID || qrcode_ID" :value="qrcode_value" :size="qrcode_size" id="myprintd"></qrcode-vue>
          </div>
          <div style="margin-top:40px">
            <div v-html="textarea"></div>
          </div>
        </el-card>
      </div>

      <el-button class="no-print" type="info" @click="print()" style="margin-top: 10px; margin-bottom: 10px">列印</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import QrcodeVue from "qrcode.vue";
import { VueEditor } from "vue2-editor";

export default {
  components: {
    QrcodeVue,
    VueEditor
  },
  data() {
    return {
      textarea: "",
      qrcode_value: "",
      selected_area: "",
      selected_qrcode: "",
      selected_floor: "4",
      floor: "",
      areas: [],
      areas_options: [],
      qrcode_options: [],
      area: "",
      qrcode_size: 300,
      font_size: "",
      img_size: ""
    };
  },
  computed: {
    ...mapState(["area_ID", "qrcode_ID"])
  },
  mounted() {
    this.$store.commit("set_page", location.hash);

    this.areas = JSON.parse(localStorage.getItem("areas"));
    this.areas.forEach(el => {
      if (el.recno == this.area_ID) {
        this.selected_floor = el.floor;
        this.floor = el.floor;
        this.area = el["area_zh-TW"];
        this.selected_area = el;
      }
    });

    this.initAreas();
    this.createQRcode();
  },
  methods: {
    changeFloor() {
      this.selected_area = "";
      this.selected_qrcode = "";
      this.$store.commit("setArea_ID", "");

      this.initAreas();
      this.createQRcode();
    },
    changeArea(area) {
      console.log(area);
      this.areas.forEach(el => {
        if (el.recno == area.recno) {
          this.selected_floor = el.floor;
          this.floor = el.floor;
          this.area = el["area_zh-TW"];
          this.selected_area = el;
        }
      });

      this.$store.commit("setArea_ID", area.recno);

      this.createQRcode();
    },
    changeQRcode(val) {
      console.log(val);
      this.selected_qrcode = val;
      this.$store.commit("setQrcode_ID", val.recno);

      this.createQRcode();
    },
    createQRcode() {
      if (this.qrcode_ID) {
        this.qrcode_value = "http://intro.taogmuseum.org/#/QRcode/" + this.qrcode_ID;
      } else {
        if (this.area_ID == -1) {
          this.qrcode_value = "http://intro.taogmuseum.org/";
        } else if (this.area_ID) {
          this.qrcode_value = "http://intro.taogmuseum.org/#/Floor/" + this.floor + "/Area/" + this.area_ID;
        }
      }
      console.log(this.qrcode_value);
    },
    initAreas() {
      this.qrcode_options = [];
      this.areas_options = [];
      if (this.selected_floor == "1") {
        this.areas_options = this.areas.filter(el => {
          return el.floor == 1;
        });
      } else if (this.selected_floor == "2") {
        this.areas_options = this.areas.filter(el => {
          return el.floor == 2;
        });
      } else if (this.selected_floor == "3") {
        this.areas_options = this.areas.filter(el => {
          return el.floor == 3;
        });
      } else if (this.selected_floor == "4") {
        this.areas_options = [];
        this.$store.commit("setArea_ID", -1);
      } else if (this.selected_floor == "0") {
        this.areas_options = [];
        let qrcodes = JSON.parse(localStorage.getItem("qrcodes"));
        this.$store.commit("setQrcode_ID", "");
        this.qrcode_options = qrcodes;
      }
    },
    setSize(val) {
      if (val == 1) {
        this.qrcode_size = 200;
        this.font_size = { "font-size": "18px" };
        this.img_size = "200px";
      } else if (val == 2) {
        this.qrcode_size = 250;
        this.font_size = { "font-size": "22px" };
        this.img_size = "250px";
      } else if (val == 3) {
        this.qrcode_size = 300;
        this.font_size = { "font-size": "26px" };
        this.img_size = "300px";
      } else if (val == 4) {
        this.qrcode_size = 350;
        this.font_size = { "font-size": "30px" };
        this.img_size = "350px";
      } else if (val == 5) {
        this.qrcode_size = 400;
        this.font_size = { "font-size": "34px" };
        this.img_size = "400px";
      }

      this.createQRcode();
    },
    print() {
      window.print();
    },
    newPage() {
      window.open(this.qrcode_value);
    }
  }
};
</script>
